<template>
  <div>
    <canvas class="canvas" ref="canvasRef"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return { data: [], breakpoint: [] };
      }
    }
  },
  data() {
    return {
      canvas: null,
      step: 300
    };
  },
  methods: {
    init() {
      this.canvas = this.$refs.canvasRef;
      if (!this.canvas) return;
      let ctx = this.canvas.getContext("2d");
      this.canvas.width = this.canvas.clientWidth * window.devicePixelRatio;
      this.canvas.height = this.canvas.clientHeight * window.devicePixelRatio;
      // 缩放绘图上下文
      ctx.scale(1, 1);

      let canvasWidth = this.canvas.width;
			let canvasWidth2 = canvasWidth - 20
      let canvasHeight = this.canvas.height;
      ctx.imageSmoothingEnabled = false;
      ctx.lineWidth = 1;

      // 设置颜色和文字
      const teacherColor = "#5470C6"; // 老师的颜色
      const studentColor = "#91CC75"; // 学生的颜色
      const fontSize = 14; //字体大小

      ctx.fillStyle = teacherColor;
      this.drawRoundedRect(ctx, 0, canvasHeight - 20, 20, 15, 4);
      // ctx.fillRect(0, canvasHeight - 20, 25, 20);
      ctx.fillStyle = "black";
      ctx.font = `${fontSize}px serif`;
      ctx.fillText("老师", 28, canvasHeight - 7);

      ctx.fillStyle = studentColor;
      // ctx.fillRect(100, canvasHeight - 20, 25, 20);
      this.drawRoundedRect(ctx, 100, canvasHeight - 20, 20, 15, 4);
      ctx.fillStyle = "black";
      ctx.font = `${fontSize}px serif`;
      ctx.fillText("学生", 128, canvasHeight - 7);
      let sum = this.data.data.reduce((pre, cur) => (pre += cur.value), 0);
			console.log(sum)
      // 当前x位置的起始点
      let currentX = 10;
      // 计算并绘制每个区域
      this.data.data.forEach(i => {
        const segmentWidth = parseFloat(
          (i.value / (sum / canvasWidth2)).toFixed(2)
        );
        ctx.fillStyle = i.type == 0 ? teacherColor : studentColor;
        ctx.fillRect(currentX, 20, segmentWidth, canvasHeight - 100);

        // 更新x位置
        currentX += segmentWidth;
      });

      // 绘制红色垂直线（指定位置）
      // ctx.strokeStyle = "red";
      // ctx.lineWidth = 2;

      // this.data.breakpoint.forEach(i => {
      //   const breakpointPo = parseFloat((i / (sum / canvasWidth2)).toFixed(2));
      //   ctx.beginPath();
      //   ctx.moveTo(breakpointPo, 10);
      //   ctx.lineTo(breakpointPo, canvasHeight - 70);
      //   ctx.stroke();
      // });

      let interval = parseFloat((this.step / (sum / canvasWidth2)).toFixed(2));
      //绘制竖线
      for (let i = 0; i < canvasWidth2; i += interval) {
        ctx.beginPath();
				ctx.strokeStyle = '#BFBFBF'
        ctx.moveTo(i==0?10:i, canvasHeight - 70);
        ctx.lineTo(i==0?10:i, canvasHeight - 55);
        ctx.stroke();
				ctx.fillStyle = "#868686";
        let timeLabel = (((i / canvasWidth2) * sum)/60).toFixed(0); // 时间标识计算
				ctx.font = `${fontSize}px serif`;
				if(i==0){
					ctx.fillText(`${timeLabel}min`, i+10, canvasHeight - 40);
				}else if((i+interval)> canvasWidth2){
					ctx.fillText(`${timeLabel}min`, i - 20, canvasHeight - 40);
				}else{
					ctx.fillText(`${timeLabel}min`, i-15, canvasHeight - 40);
				}
      }

			ctx.beginPath();
			ctx.strokeStyle = '#BFBFBF'
			ctx.moveTo(10, canvasHeight - 55);
			ctx.lineTo(canvasWidth2+10, canvasHeight - 55);
			ctx.stroke();
    },
    drawRoundedRect(ctx, x, y, width, height, radius) {
      // 限制 radius 的最大值，防止它超过矩形的宽度或高度的一半
      const actualRadius = Math.min(radius, width / 2, height / 2);

      ctx.beginPath();
      ctx.moveTo(x + actualRadius, y); // 起点，矩形顶部的左侧

      // 右上角的弧线
      ctx.arcTo(x + width, y, x + width, y + height, actualRadius);

      // 右下角的弧线
      ctx.arcTo(x + width, y + height, x, y + height, actualRadius);

      // 左下角的弧线
      ctx.arcTo(x, y + height, x, y, actualRadius);

      // 左上角的弧线
      ctx.arcTo(x, y, x + width, y, actualRadius);

      ctx.closePath();
      ctx.fill(); // 填充颜色
    },
		formatTime(seconds) {
  let h = Math.floor(seconds / 3600); // 小时
  let m = Math.floor((seconds % 3600) / 60); // 分钟
  let s = Math.floor(seconds % 60); // 秒数
  
  // 格式化为两位数
  let formattedTime;
  if (h > 0) {
    // 如果有小时部分，格式化为 hh:mm:ss
    formattedTime = `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  } else {
    // 否则，格式化为 mm:ss
    formattedTime = `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }
  return formattedTime;
}
  },
  mounted() {
    this.init();
    window.addEventListener("resize", () => {
      if (!this.$refs.canvasRef) return;
      this.init();
    });
  }
};
</script>

<style scoped>
.canvas {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/echartsSpectrogram.vue